var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "root", class: { "sm-down": _vm.$wf.isSmDown } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("green-book")))]),
      _c(
        "w-row",
        { staticClass: "ledger-row" },
        [
          _c(
            "w-col",
            {
              staticClass: "ledger-col",
              attrs: { xs: "12", md: _vm.hasDocuments ? 7 : 12 },
            },
            [
              _c(
                "w-card-content",
                [
                  _vm.favorites.length
                    ? _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "4" } },
                            [
                              _c("w-select", {
                                attrs: {
                                  value: _vm.selectedFavoriteId,
                                  items: _vm.favoriteItems,
                                  label: _vm.$ct("favorites.label"),
                                  fancy: "",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.applyFavorite($event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("app-purchase-edit-ledger", {
                    attrs: { value: _vm.toEditLedger, purchase: _vm.p },
                    on: {
                      input: function ($event) {
                        return _vm.onInput($event)
                      },
                      remove: function ($event) {
                        return _vm.removeLedger()
                      },
                    },
                  }),
                ],
                1
              ),
              _vm.$wf.isSmDown
                ? _c("app-purchase-edit-ledgers-mobile", {
                    attrs: {
                      purchase: _vm.p,
                      "selected-item": _vm.toEditLedger,
                    },
                    on: {
                      "selected-item": function ($event) {
                        return _vm.onItemSelected($event)
                      },
                      "set-new-empty-ledger": function ($event) {
                        return _vm.setNewEmptyEditLedgerValue()
                      },
                    },
                  })
                : _c("app-purchase-edit-ledgers", {
                    attrs: {
                      purchase: _vm.p,
                      "selected-item": _vm.toEditLedger,
                    },
                    on: {
                      "selected-item": function ($event) {
                        return _vm.onItemSelected($event)
                      },
                    },
                  }),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c("w-col", { attrs: { xs: "12" } }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$ct("total-booked", {
                                value: _vm.totalBooked,
                              })
                            ) +
                            " "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.hasDocuments
            ? _c(
                "w-col",
                { staticClass: "documents-col", attrs: { xs: "12", md: "5" } },
                [
                  _c("app-purchase-documents", {
                    attrs: { value: _vm.purchase, "preview-only": "" },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              staticClass: "favorite-save-link mr",
              on: {
                click: function ($event) {
                  return _vm.openSaveFavoriteModal()
                },
              },
            },
            [
              _c("w-fa", {
                staticClass: "mrs",
                attrs: { icon: ["far", "heart"] },
              }),
              _vm._v(_vm._s(_vm.$ct("favorites.save")) + " "),
            ],
            1
          ),
          _c(
            "w-button",
            {
              attrs: { icon: "check", disabled: !_vm.isValid },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.confirm")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { value: _vm.showFavoriteNameModal },
          on: {
            input: function ($event) {
              _vm.showFavoriteNameModal = $event
            },
          },
        },
        [
          _c(
            "w-card",
            { attrs: { "max-width": "500" } },
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("favorites.label")))]),
              _c(
                "w-card-content",
                [
                  _c("w-input", {
                    attrs: {
                      label: _vm.$ct("favorites.name"),
                      fancy: "",
                      autofocus: "",
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.confirmSaveFavorite()
                      },
                    },
                    model: {
                      value: _vm.favoriteName,
                      callback: function ($$v) {
                        _vm.favoriteName = $$v
                      },
                      expression: "favoriteName",
                    },
                  }),
                  _vm.favorites.length
                    ? _c(
                        "div",
                        { staticClass: "favorites-section" },
                        [
                          _c(
                            "div",
                            { staticClass: "favorites-section-title" },
                            [_vm._v(_vm._s(_vm.$ct("favorites.saved-title")))]
                          ),
                          _c(
                            "w-list",
                            { staticClass: "favorites-list" },
                            _vm._l(_vm.favorites, function (favorite) {
                              return _c(
                                "w-list-item",
                                {
                                  key: favorite.ID,
                                  staticClass: "favorite-item",
                                },
                                [
                                  _c("w-list-item-text", [
                                    _c(
                                      "div",
                                      { staticClass: "favorite-name" },
                                      [_vm._v(_vm._s(favorite.Name))]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "favorite-summary" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getFavoriteSummary(favorite)
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "w-list-item-action",
                                    [
                                      _c(
                                        "w-link",
                                        {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip",
                                              value:
                                                _vm.$ct("favorites.delete"),
                                              expression:
                                                "$ct('favorites.delete')",
                                            },
                                          ],
                                          staticClass: "favorite-delete-link",
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteFavorite(
                                                favorite
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("w-fa", {
                                            attrs: { icon: "trash" },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "w-card-actions",
                [
                  _c(
                    "w-button",
                    {
                      staticClass: "cancel",
                      attrs: { icon: "ban" },
                      on: {
                        click: function ($event) {
                          _vm.showFavoriteNameModal = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      attrs: {
                        disabled:
                          !_vm.favoriteName.trim() ||
                          !_vm.p.Ledgers.length ||
                          _vm.savingFavorite,
                        icon: "check",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.confirmSaveFavorite()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.save")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }